import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/styles/mobile-native.css";
import App from "@/App";
import { initNativeApp } from "@/utils/nativeApp";

// Initialize native app features
const { isNative, platform } = initNativeApp();
if (process.env.NODE_ENV === 'development') {
  console.log(`[Compass] Running as ${isNative ? 'native' : 'web'} app on ${platform}`);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register Service Worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        // Check for updates periodically
        setInterval(() => {
          registration.update();
        }, 60 * 60 * 1000); // Check every hour
        
        // Handle updates silently
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New version available - handled silently
            }
          });
        });
      })
      .catch(() => {
        // Service Worker registration failed silently
      });
  });
}
